import { useEffect, useState } from 'react'
import { useDeliveryOrderLoaders } from '../../../deliveries'
import { usePurchaseLoaders } from '../../../purchases'
import { useSystemStateHooks } from '../../../system'
import { DeliveryOrder, DeliveryMethod, DeliveryStatus } from '../../../deliveries'
import { PurchaseOrder } from '../../../purchases'

export type AdminOpsData = {
    pendingShipments: DeliveryOrder[]
    pendingReceptions: PurchaseOrder[]
}

// enabled: false when no visible card needs this data (it isn't loaded)
export const useAdminOpsData = (enabled = true) => {
    const [loading, setLoading] = useState(enabled)
    const [error, setError] = useState(false)
    const [data, setData] = useState<AdminOpsData | null>(null)

    const { companyId } = useSystemStateHooks()
    const deliveryOrderLoaders = useDeliveryOrderLoaders()
    const purchaseLoaders = usePurchaseLoaders()

    useEffect(() => {
        if (!enabled) return
        setLoading(true)
        const load = async () => {
            try {
                const id = companyId

                const [deliveryOrdersRes, allPurchases] = await Promise.all([
                    deliveryOrderLoaders(id).loadDeliveryOrdersBatch({
                        valueFilters: [
                            { prop: 'method', value: DeliveryMethod.SHIPMENT }
                        ]
                    }),
                    purchaseLoaders(id).loadAllPurchases()
                ])

                const pendingShipments = deliveryOrdersRes.dataTypes.filter(
                    d => !d.cancelled && (d.deliveryStatus === DeliveryStatus.PENDING || d.deliveryStatus === DeliveryStatus.PARTIALLY_DELIVERED)
                )

                const pendingReceptions = allPurchases.filter(
                    p => !p.archived && p.deliveryStatus !== DeliveryStatus.DELIVERED
                )

                setData({ pendingShipments, pendingReceptions })
            } catch {
                setError(true)
            } finally {
                setLoading(false)
            }
        }
        load()
    }, [enabled])

    return { loading, error, data }
}
